/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/st_buffer.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Computes a buffer area around the input geometry at the specified distance. The distance is in the units of the input spatial reference system. Positive distances expand the geometry, negative distances shrink it. A distance of zero will return the input geometry unchanged. Points and lines become polygons when buffered, unless a zero distance is provided.',
  examples: [
    'ROW wkt = "POLYGON ((0 0, 4 0, 4 4, 0 4, 0 0))"\n| EVAL buffered = ST_BUFFER(TO_GEOSHAPE(wkt), -1)',
    'ROW geom = TO_CARTESIANSHAPE("LINESTRING(0 0, 10 0, 10 10)")\n| EVAL buffered = ST_BUFFER(geom, 2, {"endcap": "flat", "join": "mitre"})\n| KEEP buffered',
  ],
  params: {
    geometry: 'Expression of type `geo_point`, `geo_shape`, `cartesian_point` or `cartesian_shape`. If `null`, the function returns `null`.',
    distance: 'Buffer distance in the units of the input spatial reference system',
  },
};

export default docs;
